import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  label: 'Teams Registered',
  value: '340+',
  color: 'text-neon-cyan'
}, {
  label: 'Deals Facilitated',
  value: '€2.1M+',
  color: 'text-neon-lime'
}, {
  label: 'Brands Active',
  value: '89',
  color: 'text-neon-magenta'
}, {
  label: 'Countries',
  value: '12',
  color: 'text-white'
}];
export function Stats() {
  return <section className="py-12 border-y border-white/10 bg-dark-lighter/50 backdrop-blur-sm relative z-20" data-id="element-330">
      <div className="container mx-auto px-6" data-id="element-331">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 divide-x divide-white/10" data-id="element-332">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="text-center px-4" data-id="element-333">
              <div className={`font-rajdhani text-4xl md:text-5xl font-bold mb-2 ${stat.color}`} data-id="element-334">
                {stat.value}
              </div>
              <div className="text-sm text-gray-400 uppercase tracking-widest font-medium" data-id="element-335">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}